import { DELETE_TABLE_LIST_FAILURE, DELETE_TABLE_LIST_REQUEST, DELETE_TABLE_LIST_SUCCESS, 
    GET_BYID_TABLE_LIST_FAILURE, GET_BYID_TABLE_LIST_REQUEST, GET_BYID_TABLE_LIST_SUCCESS, 
    GET_TABLE_LIST_FAILURE, GET_TABLE_LIST_REQUEST, GET_TABLE_LIST_SUCCESS, 
    POST_TABLE_LIST_FAILURE, POST_TABLE_LIST_REQUEST, POST_TABLE_LIST_SUCCESS, 
    PUT_TABLE_LIST_FAILURE, PUT_TABLE_LIST_REQUEST, PUT_TABLE_LIST_SUCCESS } from "../../../Utils/Constant";

export const getTableRequest = (payload) => {
    return {
        type: GET_TABLE_LIST_REQUEST,
        payload: payload,
    };
};

export const getTableSuccess = (data) => {
    return {
        type: GET_TABLE_LIST_SUCCESS,
        payload: data,
    };
};

export const getTableFailure = (error) => {
    return {
        type: GET_TABLE_LIST_FAILURE,
        payload: error,
    };
};

//add room
export const addTableRequest = (payload) => {
    return {
        type: POST_TABLE_LIST_REQUEST,
        payload: payload,
    };
};

export const addTableSuccess = (data) => {
    return {
        type: POST_TABLE_LIST_SUCCESS,
        payload: data,
    };
};

export const addTableFailure = (error) => {
    return {
        type: POST_TABLE_LIST_FAILURE,
        payload: error,
    };
};

//deleteroom
export const deleteTableRequest = (payload) => {
    return {
        type: DELETE_TABLE_LIST_REQUEST,
        payload: payload,
    };
};

export const deleteTableSuccess = (data) => {
    return {
        type: DELETE_TABLE_LIST_SUCCESS,
        payload: data,
    };
};

export const deleteTableFailure = (error) => {
    return {
        type: DELETE_TABLE_LIST_FAILURE,
        payload: error,
    };
};

//get by id
export const getByIdTableRequest = (payload) => {
    return {
        type: GET_BYID_TABLE_LIST_REQUEST,
        payload: payload,
    };
};

export const getByIdTableSuccess = (data) => {
    return {
        type: GET_BYID_TABLE_LIST_SUCCESS,
        payload: data,
    };
};

export const getByIdTableFailure = (error) => {
    return {
        type: GET_BYID_TABLE_LIST_FAILURE,
        payload: error,
    };
};

//update by id
export const updateTableRequest = (payload) => {
    return {
        type: PUT_TABLE_LIST_REQUEST,
        payload: payload,
    };
};

export const updateTableSuccess = (data) => {
    return {
        type: PUT_TABLE_LIST_SUCCESS,
        payload: data,
    };
};

export const updateTableFailure = (error) => {
    return {
        type: PUT_TABLE_LIST_FAILURE,
        payload: error,
    };
};
